// First-touch acquisition snapshot for signup (growth-plan Phase 0).
// The homepage persists UTM/referrer into an `imgaff_attr` cookie on
// .imgaff.com (readable here on app.imgaff.com); the cookie wins, and any UTM
// params on the signup URL itself fill in keys the cookie doesn't have
// (direct-to-portal ad clicks). Attribution is telemetry: any failure returns
// undefined, never throws.
const ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'referrer', 'landing_page'];

export function collectAttribution(): Record<string, string> | undefined {
  try {
    let attr: Record<string, string> = {};
    const m = document.cookie.match(/(?:^|; )imgaff_attr=([^;]+)/);
    if (m) {
      try {
        const parsed = JSON.parse(decodeURIComponent(m[1]));
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
          // Whitelist here too (not only server-side): a stale cookie from an
          // older/newer script version must not smuggle unknown keys into the
          // signup payload.
          ATTR_KEYS.forEach(k => {
            if (typeof parsed[k] === 'string' && parsed[k]) attr[k] = String(parsed[k]).slice(0, 200);
          });
        }
      } catch {
        // malformed cookie: ignore it, URL params below still count
      }
    }
    const p = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(k => {
      const v = p.get(k);
      if (v && !attr[k]) attr[k] = v.slice(0, 200);
    });
    return Object.keys(attr).length ? attr : undefined;
  } catch {
    return undefined;
  }
}
